module.exports = __webpack_public_path__ + "static/blow-motor-3738ef6a99a457eb81aca0c2c01d7f38.jpg";